module.exports = __webpack_public_path__ + "img/alarmy.a8c1e74d.webp";